import { Modal } from 'antd';
import React from 'react';

export default function ModalRouterPrompt(props) {
  const {
    title = 'Leave this page',
    description = 'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
    okText = 'Confirm',
    cancelText = 'Cancel',
    open = false,
    handleOK,
    handleCancel,
  } = props;

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOK}
      okText={okText}
      onCancel={handleCancel}
      cancelText={cancelText}
      centered
    >
      {description}
    </Modal>
  );
}
